var _defs, _path, _rect, _line, _line2, _line3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.b{stroke:#51b2cd;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 12,
    rx: 1,
    transform: "translate(3 4)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x2: 10,
    transform: "translate(7 20)"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 4,
    transform: "translate(9 16)"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    y2: 4,
    transform: "translate(15 16)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/deviceIcon.28db5b648bf66bbb283767fbb39c2434.svg";
export { ForwardRef as ReactComponent };